<template>
  <div class="chooseGradeClass">
    <Cascader
      v-model="formValidate.classData"
      clearable
      :data="gradeAndClassList"
      placeholder="请选择年级班级"
      :change-on-select="true"
      @on-visible-change="handleGradeSelect"
      @on-change="onChange"
    ></Cascader>
  </div>
</template>

<script>
import common from '@/request/common/index.js';
export default {
  props: {
    schoolId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      gradeAndClassList: [],
      formValidate: {
        classData: []
      },
      selectedData: []
    }
  },
  watch: {
    schoolId(newVal) {
      this.formValidate.classData = []
      this.selectedData = []
      if (newVal) {
        this.getGradeAndClass()
      }
    }
  },
  methods: {
    // 选择年级之前，先看有没有选学校
    handleGradeSelect(status) {
      if (!this.schoolId) {
        return this.$Message.error('请先选择学校！');
      }
    },
    handleClear() {
      this.selectedData = []
      this.formValidate.classData = []
    },
    getResult() {
      return this.formValidate.classData
    },
    getSelectedData() {
      return this.selectedData
    },
    onChange(value, selectedData) {
      console.log(value, selectedData)
      this.selectedData = selectedData
      this.$emit('on-change', value)
    },
    // 请求年级班级列表
    async getGradeAndClass() {
      if (!this.schoolId) return;
      const params = {
        schoolId: this.schoolId
      };

      const res = await common.getListOrgGradeClass(params);
      if (res.status === 200) {
        this.gradeAndClassList = res.message;
      }
    },
  }
}
</script>

<style>
</style>